module.exports = __webpack_public_path__ + "static/media/rocket.598dfb6d.svg";